<template>
  <div class="popup_in">
    <div class="popup">
      <div class="popup_close close-animate">
        <a href="javascript:void(0);" @click="$emit('close')"><CloseSvg /></a>
      </div>
      <div class="title">תורים פנויים נוספים:</div>
      <div class="book_hours_wrap inner_group bg--white">
        <div class="add_new_row flex">
          <div class="add_new_row_col1">
            21/12/19<span class="block">יום ג׳</span>
          </div>
          <div class="book_hours_slide flex flex--start">
            <swiper
              ref="hoursSlider"
              class=""
              :options="swiperOptions"
              :auto-update="true"
              :auto-destroy="true"
              :delete-instance-on-destroy="true"
              :cleanup-styles-on-destroy="true"
            >
              <swiper-slide>
                <a class="book_hure ease" href="javascript:void(0)">14:40</a>
              </swiper-slide>
              <swiper-slide>
                <a class="book_hure ease " href="javascript:void(0)">17:40</a>
              </swiper-slide>
              <swiper-slide>
                <a class="book_hure ease " href="javascript:void(0)">18:40</a>
              </swiper-slide>
              <swiper-slide>
                <a class="book_hure ease " href="javascript:void(0)">19:40</a>
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <div class="add_new_row flex">
          <div class="add_new_row_col1">
            22/12/19<span class="block">יום ד׳</span>
          </div>
          <div class="book_hours_slide flex flex--start">
            <swiper
              ref="hoursSlider"
              class=""
              :options="swiperOptions"
              :auto-update="true"
              :auto-destroy="true"
              :delete-instance-on-destroy="true"
              :cleanup-styles-on-destroy="true"
            >
              <swiper-slide>
                <a class="book_hure ease" href="javascript:void(0)">14:40</a>
              </swiper-slide>
              <swiper-slide>
                <a class="book_hure ease " href="javascript:void(0)">17:40</a>
              </swiper-slide>
              <swiper-slide>
                <a class="book_hure ease " href="javascript:void(0)">18:40</a>
              </swiper-slide>
              <swiper-slide>
                <a class="book_hure ease " href="javascript:void(0)">19:40</a>
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <div class="add_new_row flex">
          <div class="add_new_row_col1">
            21/12/19<span class="block">יום ג׳</span>
          </div>
          <div class="book_hours_slide flex flex--start">
            <swiper
              ref="hoursSlider"
              class=""
              :options="swiperOptions"
              :auto-update="true"
              :auto-destroy="true"
              :delete-instance-on-destroy="true"
              :cleanup-styles-on-destroy="true"
            >
              <swiper-slide>
                <a class="book_hure ease" href="javascript:void(0)">14:40</a>
              </swiper-slide>
              <swiper-slide>
                <a class="book_hure ease " href="javascript:void(0)">17:40</a>
              </swiper-slide>
              <swiper-slide>
                <a class="book_hure ease " href="javascript:void(0)">18:40</a>
              </swiper-slide>
              <swiper-slide>
                <a class="book_hure ease " href="javascript:void(0)">19:40</a>
              </swiper-slide>
            </swiper>
          </div>
        </div>
        <div class="add_new_row flex">
          <div class="add_new_row_col1">
            22/12/19<span class="block">יום ד׳</span>
          </div>
          <div class="book_hours_slide flex flex--start">
            <swiper
              ref="hoursSlider"
              class=""
              :options="swiperOptions"
              :auto-update="true"
              :auto-destroy="true"
              :delete-instance-on-destroy="true"
              :cleanup-styles-on-destroy="true"
            >
              <swiper-slide>
                <a class="book_hure ease" href="javascript:void(0)">14:40</a>
              </swiper-slide>
              <swiper-slide>
                <a class="book_hure ease " href="javascript:void(0)">17:40</a>
              </swiper-slide>
              <swiper-slide>
                <a class="book_hure ease " href="javascript:void(0)">18:40</a>
              </swiper-slide>
              <swiper-slide>
                <a class="book_hure ease " href="javascript:void(0)">19:40</a>
              </swiper-slide>
            </swiper>
          </div>
        </div>
      </div>

      <div class="flex flex--content--center">
        <a class="bt_blue" href="">אישור</a>
      </div>
    </div>
  </div>
</template>

<script>
import CloseSvg from "../../assets/img/svg/close.svg";
export default {
  name: "Hours",
  data() {
    return {
      swiperOptions: {
        slidesPerView: "3",
        spaceBetween: 0,
        centeredSlides: true,
        centeredSlidesBounds: true
      }
    };
  },
  components: {
    CloseSvg
  }
};
</script>

<style scoped>
/*
  .swiper-slide {
  width: auto;
}*/
.book_hours_slide {
  padding-left: 0px;
}
</style>
